import { Box, styled } from '@mui/material'

export const DialogContentBox = styled(Box, { shouldForwardProp: prop => prop !== 'isSubmitting' })<{
  isSubmitting: boolean
}>(({ isSubmitting }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  pointerEvents: isSubmitting ? 'none' : 'auto',
  opacity: isSubmitting ? 0.6 : 1,
}))
